import DAILogo from '../assets/DAILogo.svg';
import TetherLogo from '../assets/tether-usdt-logo.svg';
import USDCLogo from '../assets/usd-coin-usdc-logo.svg';


const CurrencyModal = () => {
    //TODO: Add New Token Here
    const TestToken = {
        address: process.env.REACT_APP_TOKEN_ADDRESS,
        name: "Test Token",
        decimal: 18,
        img: DAILogo
    };

    const USDCInfo = {
        address: process.env.REACT_APP_USDC_ADDRESS,
        name: "USDC",
        decimal: 6,
        img: USDCLogo
    };

    const USDTInfo = {
        address: process.env.REACT_APP_USDT_ADDRESS,
        name: "USDT",
        decimal: 6,
        img: TetherLogo
    };
    const DAIInfo = {
        address: process.env.REACT_APP_DAI_ADDRESS,
        name: "DAI",
        decimal: 18,
        img: DAILogo
    };

    return [TestToken, USDTInfo, USDCInfo, DAIInfo];
}

export default CurrencyModal;